import React, {Component} from 'react';
import {Form} from 'reactstrap';
import {Field, reduxForm, FieldArray} from 'redux-form'
import {FieldTxt, FieldCheckbox, FieldSelect2, FieldSelect, FieldSelectAsync} from '../wh-field';
import {Button, ModalBody, ModalFooter, Alert} from 'reactstrap';
import LaddaButton, { EXPAND_LEFT } from 'react-ladda';
import FieldContents from "../wh-contents";

class UserFormPopup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false
        };

    }


    render() {

        const {error, handleSubmit, pristine, reset, submitting} = this.props;

        return (

            <Form onSubmit={handleSubmit} className="form-vertical">

                <ModalBody>

                    <FieldArray name="childrens" component={FieldContents} />


                    {error && <Alert color="danger"><div dangerouslySetInnerHTML={{__html: error}} /></Alert>}

                </ModalBody>
                <ModalFooter>

                    <LaddaButton
                        className="btn btn-success btn-ladda"
                        loading={submitting}
                        data-style={EXPAND_LEFT}
                        type={'submit'}
                    >
                        <i className="fa fa-save"></i> Enregistrer </LaddaButton>

                </ModalFooter>

            </Form>

        );


    }
}

UserFormPopup = reduxForm({
    form: 'UserFormPopup'
})(UserFormPopup);

export default UserFormPopup



// WEBPACK FOOTER //
// ./src/components/Form/popup/Form.js